<template lang="pug">
form.prose-stack.w-full
  fieldset
    label
      .question__text.prose-stack.mb-8.fade-in
        uc-editable.font-bold(
          :editPath="`${editPath}.question`"
          :k="`${screen.id}.question`"
          :text="screen.question"
          v-model="input"
        )
      textarea.transition.w-full.p-4.resize-none.ring-1.focus_ring-4.shadow-sm.rounded-md.dark_bg-gray-900.fade-in(
        class="min-h-[8rem] dark_bg-gray-900/50 ring-gray-800/20 dark_ring-gray-200/20 focus_ring-sky-500/50 dark_focus_ring-sky-400/40 dark_highlight-white/5"
        ref="elRef"
        :disabled="isInsightsDataSubmitted()"
        v-model="input"
      )
</template>

<script setup lang="ts">
import { useTextareaAutosize } from '@vueuse/core';
import { inject, watchEffect } from 'vue';
// import { onMounted, ref } from 'vue';
import SCORM from '../lib/SCORM';
import bugAlert from '../lib/bugAlert';
import {
  saveInsightsData,
  getInsightsData,
  isInsightsDataSubmitted
} from '../lib/insightsData';

// const elRef = ref<HTMLTextAreaElement>();
const props = defineProps<{ editPath: string; screen: UcScreenRequiredId }>();

const getId = () => `inputs.` + props.screen.id;
const sectionId = inject<string>('sectionId');

watchEffect(() => {
  if (!props.screen.id) {
    bugAlert(`Missing ID on textarea in section #${sectionId}`);
  }
});

const { textarea: elRef, input } = useTextareaAutosize({
  input: getInsightsData(props.screen)?.text || (SCORM.get(getId()) as string),
  onResize: () => {
    elRef.value.closest('.page').refreshSections();
  }
});

// const onChange = (e: InputEvent) => {
//   const target = e.target as HTMLTextAreaElement;
//   SCORM.set(getId(), target.value);
// };

watchEffect(() => {
  if (input.value) {
    if (props.screen['insights-data']) {
      if (!isInsightsDataSubmitted()) {
        saveInsightsData(props.screen, {
          text: input.value
        });
      }
    } else {
      SCORM.set(getId(), input.value);
    }
  }
});

// onMounted(() => {
// const value = SCORM.get(getId()) as string;

// if (value) elRef.value.value = value;

// });
</script>
